import { User } from "./types";
import { masqueradeToken } from "@/util";

export default class FreshpaintUser {
  user: User | undefined;

  constructor(user: User | undefined) {
    this.user = user;
  }

  get uid() {
    if (this.user) {
      return this.user.uid;
    }
    return null;
  }

  hasAdminAccess() {
    if (masqueradeToken()) {
      return true;
    }
    return this.user?.role === "admin";
  }
}
